import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ILayoutConf, LayoutService } from 'app/services/layout.service';
import { AuthService } from 'app/services/auth/auth.service';
import { ThemeService } from 'app/services/theme.service';
import { NavigationService } from 'app/services/navigation.service';

@Component({
    selector: 'app-sidebar-side',
    templateUrl: './sidebar-side.component.html',
})
export class SidebarSideComponent implements OnInit, OnDestroy, AfterViewInit {
    public menuItems: any[];
    public hasIconTypeMenuItem: boolean;
    public iconTypeMenuTitle: string;
    private menuItemsSub: Subscription;
    public layoutConf: ILayoutConf;

    constructor(
        private navService: NavigationService,
        public themeService: ThemeService,
        private layout: LayoutService,
        public authService: AuthService
    ) {}

    ngOnInit() {
        this.iconTypeMenuTitle = this.navService.iconTypeMenuTitle;
        this.menuItemsSub = this.navService.menuItems$.subscribe((menuItem) => {
            this.menuItems = menuItem;
            // Checks item list has any icon type.
            this.hasIconTypeMenuItem = !!this.menuItems.filter((item) => item.type === 'icon').length;
        });
        this.layoutConf = this.layout.layoutConf;
    }

    signOut() {
        this.authService.signOut();
    }

    ngAfterViewInit() {}

    ngOnDestroy() {
        if (this.menuItemsSub) {
            this.menuItemsSub.unsubscribe();
        }
    }
    toggleCollapse() {
        if (this.layoutConf.sidebarCompactToggle) {
            this.layout.publishLayoutChange({
                sidebarCompactToggle: false,
            });
        } else {
            this.layout.publishLayoutChange({
                // sidebarStyle: "compact",
                sidebarCompactToggle: true,
            });
        }
    }
}
